import React from "react";
import cn from "classnames";
import styles from "./Program.module.sass";
import { Link } from "react-router-dom";

const FonctionnalitesContrat = () => {
  return (
    <div className={cn("section-bg", styles.book)}>
      {/* Conteneur d'image qui s'étend sur le côté droit de l'écran */}
      <div className={styles.imageContainer}>
        <img
          src="/images/content/image-58.png"
          alt="Interface de gestion des absences"
          className={styles.mainImage}
        />
      </div>
      <div className={cn("section-bg", styles.section)}>
        <div className={cn("container", styles.container)}>
          {/* Left side - Text content */}
          <div className={styles.textContent}>
            <h2 className={styles.title}>
              Pourquoi optimiser votre prospection ?
            </h2>

            <div className={styles.features}>
              <div className={styles.feature}>
                <div className={styles.checkIcon}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <span>Augmentez vos taux de conversion grâce à un suivi personnalisé et des relances automatisées.</span>
              </div>
              <div className={styles.feature}>
                <div className={styles.checkIcon}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <span>Automatisez vos tâches répétitives et concentrez-vous sur les prospects les plus qualifiés.</span>
              </div>
              <div className={styles.feature}>
                <div className={styles.checkIcon}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <span>Identifiez rapidement les prospects les plus prometteurs grâce au scoring automatique.</span>
              </div>
              <div className={styles.feature}>
                <div className={styles.checkIcon}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <span>Développez votre réseau d'entreprises partenaires pour faciliter l'insertion professionnelle.</span>
              </div>
            </div>
            <div className={styles.cta}>
              <Link className={cn("button", styles.button)} to="/contact">
                Profiter d'un essai gratuit
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FonctionnalitesContrat;
